var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import convertToHTML from "draft-convert/lib/convertToHTML";
import selectn from "selectn";
import debounce from "lodash/debounce";
import classNames from "classnames";

import { loadStory } from "../../../actions/storiesStream";
import { BREAKPOINT_DOWN_SMALL, ENTITY_TYPE, BLOCK_TYPE, FACTS_MATTER_TEMPLATE } from "../../../config/constants";
import { styleToHTML, blockToHTML } from "./conversionHelpers";
import { entityToHTML } from "../../../utils/entityToHTML";
import { handleEmbed } from "../../../utils/embed";
import { isInternalURL } from "../../../utils/utils";
import analytics from "../../../utils/analytics";
import { GET_STORY_ERROR } from "../../../constants/actionTypes";
import Log from "../../../utils/log";

import styles from "./StoryBody.css";
import keepReadingStyles from "../../../components/Library/KeepReading/KeepReading.css";

var StoryBody = function (_Component) {
  _inherits(StoryBody, _Component);

  function StoryBody(props) {
    _classCallCheck(this, StoryBody);

    var _this = _possibleConstructorReturn(this, (StoryBody.__proto__ || Object.getPrototypeOf(StoryBody)).call(this, props));

    _this.addInternalClickEventHandler = function (identifier) {
      var elements = document.getElementsByClassName(identifier + "-" + _this.props.story.id);

      var _loop = function _loop(i) {
        elements[i].onclick = function (e) {
          e.preventDefault();
          analytics.userClicksInternalLink(_this.props.stream, elements[i].name);
          _this.loadInternalStory(identifier).then(function (storyElement) {
            _this.scrollToStory(storyElement);
          }).catch(function () {
            window.location = elements[i].href;
          });
        };
      };

      for (var i = 0; i < elements.length; i++) {
        _loop(i);
      }
    };

    _this.loadInternalStory = function (internalStoryId) {
      return new Promise(function (resolve, reject) {
        //if this is a newsletter, redirect to the permalink without bothering with api call
        if (_this.props.storyType === "newsletter") {
          reject();
          return;
        }

        //otherwise, load the story into the stream
        _this.props.loadStory({ story: internalStoryId }, _this.props.story.id).then(function (res) {
          //this will usually happen if it's a RM link
          if (res.type === GET_STORY_ERROR) {
            reject();
          } else {
            setTimeout(function () {
              //scroll to the story if it's on the page. if not, permalink
              var storyElement = document.getElementById(internalStoryId);
              storyElement ? resolve(storyElement) : reject();
            }, 200);
          }
        });
      });
    };

    _this.scrollToStory = function (element) {
      var bounds = element.getBoundingClientRect();
      window.scrollBy(0, bounds.top - 100);
    };

    _this.processBlocks = function (blocks) {
      var newBlocks = [];
      var hiddenBlocks = [];
      var keepReading = null;
      var wordCount = 0;
      var styledQuoteAttributions = [];

      for (var i = 0; i < blocks.length; i++) {
        if (!blocks[i]) continue;
        if (i !== 0 && blocks[i].type.toLowerCase() === BLOCK_TYPE.QUOTE_ATTRIBUTION && blocks[i - 1].type.toLowerCase() === BLOCK_TYPE.STYLED_QUOTE) {
          styledQuoteAttributions.push(blocks[i].key);
        }
        if (blocks[i].type.toLowerCase() === BLOCK_TYPE.KEEP_READING) {
          keepReading = blocks[i];
        } else if (keepReading) {
          hiddenBlocks.push(blocks[i]);
          wordCount += blocks[i].text.split(" ").length;
        } else {
          newBlocks.push(blocks[i]);
        }
      }

      return {
        blocks: newBlocks,
        keepReadingBlock: keepReading,
        hiddenBlocks: hiddenBlocks,
        wordCount: wordCount,
        styledQuoteAttributions: styledQuoteAttributions
      };
    };

    _this.addListeners = function () {
      _this.mediaQuery.addListener(_this.handleResize);

      if (_this.mediaQuery.matches) {
        window.addEventListener("scroll", _this.scrollListener);
      }
    };

    _this.removeListeners = function () {
      _this.mediaQuery.removeListener(_this.handleResize);
      window.removeEventListener("scroll", _this.scrollListener);
    };

    _this.handleScroll = function () {
      if (_this.processedBlocks.keepReadingBlock && _this.state.isOpen) {
        var hidden = document.getElementById("hidden-" + _this.props.story.id);
        if (hidden) {
          var isFixed = _this.mediaQuery.matches && _this.state.isOpen && !_this.isKeepReadingVisible(hidden);
          if (_this.state.isFixed !== isFixed) {
            _this.setState({ isFixed: isFixed });
          }
        }
      }
    };

    _this.handleResize = function (event) {
      if (event.matches) {
        window.addEventListener("scroll", _this.scrollListener);
      } else {
        if (_this.state.isFixed) {
          _this.setState({ isFixed: false });
        }
        window.removeEventListener("scroll", _this.scrollListener);
      }
    };

    _this.isKeepReadingVisible = function (element) {
      var bounds = element.getBoundingClientRect();
      return bounds.bottom < (window.innerHeight || document.documentElement.clientHeight);
    };

    _this._onKeepReadingClick = function () {
      var isOpen = !_this.state.isOpen;
      _this.setState({ isOpen: isOpen });

      if (isOpen) {
        _this.addListeners();
        analytics.userClicksKeepReading(_this.props.stream);
      } else {
        _this.removeListeners();

        // If next headline is not visible, scroll to just show it
        var bounds = _this.keepReadingButton.getBoundingClientRect();
        var scrollValue = 275 + bounds.top - (window.innerHeight || document.documentElement.clientHeight);

        if (scrollValue > 0) {
          window.scrollBy(0, scrollValue);
        } else if (bounds.top < 60) {
          // If keep reading button is not visible, scroll so it just shows
          window.scrollBy(0, bounds.top - 60);
        }
      }
    };

    _this.getHTML = function (blocks, entityMap, extras) {
      var html = false;
      try {
        html = convertToHTML({
          styleToHTML: styleToHTML,
          blockToHTML: blockToHTML(extras, _this.state.isClient),
          // This shouldn't normally work, but we've tricked draft-convert into requiring a version of draft-js where
          // convertToRaw is a noop - thus we can pass raw draft data right into draft-convert
          entityToHTML: entityToHTML(_this.props.story, styles)
        })({ blocks: blocks, entityMap: entityMap });
      } catch (e) {
        Log.logger("draft-convert failure. story id: " + _this.props.story.id, "error", { id: _this.props.story.id, error: e });
      }
      return html;
    };

    _this.state = {
      isOpen: !!props.permalinkId && props.permalinkId === props.story.id,
      isFixed: false,
      isClient: false,
      shouldProcess: true
    };

    _this.onKeepReadingClick = _this._onKeepReadingClick.bind(_this);
    return _this;
  }

  _createClass(StoryBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mediaQuery = window.matchMedia(BREAKPOINT_DOWN_SMALL);
      this.scrollListener = debounce(this.handleScroll, 50);
      this.setState({ isClient: true });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (!this.state.isClient || !this.processedBlocks || !this.state.shouldProcess) return;

      if (this.processedBlocks.blocks) {
        this.processedBlocks.blocks.filter(function (block) {
          return block.type === BLOCK_TYPE.EMBED;
        }).map(handleEmbed);

        (selectn("story.blocks.entityMap", this.props) || []).filter(function (entity) {
          return entity.type.toLowerCase() === ENTITY_TYPE.LINK;
        }).map(function (entity) {
          var matches = isInternalURL(entity.data.url);
          if (matches && matches.length > 1) {
            _this2.addInternalClickEventHandler(matches[1]);
          }
        });
      }

      if (this.processedBlocks.hiddenBlocks) {
        this.processedBlocks.hiddenBlocks.filter(function (block) {
          return block.type === BLOCK_TYPE.EMBED;
        }).map(handleEmbed);
      }

      this.setState({ shouldProcess: false });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _classNames2;

      var currentBlocks = selectn("story.blocks.blocks", this.props);
      if (!currentBlocks) return null;
      this.processedBlocks = this.processBlocks(currentBlocks);
      var _processedBlocks = this.processedBlocks,
          blocks = _processedBlocks.blocks,
          hiddenBlocks = _processedBlocks.hiddenBlocks,
          keepReadingBlock = _processedBlocks.keepReadingBlock,
          wordCount = _processedBlocks.wordCount,
          styledQuoteAttributions = _processedBlocks.styledQuoteAttributions;
      var entityMap = this.props.story.blocks.entityMap;

      var extras = { styledQuoteAttributions: styledQuoteAttributions };

      var html = this.getHTML(blocks, entityMap, extras);
      var keepReadingHTML = keepReadingBlock && this.getHTML([keepReadingBlock], entityMap, { wordCount: wordCount });
      var hiddenHTML = hiddenBlocks && this.getHTML(hiddenBlocks, entityMap, extras);

      // don't render the story if draft-convert failed
      if (!html || keepReadingHTML && !hiddenHTML) return null;

      return React.createElement(
        "div",
        { className: classNames(styles.root, _defineProperty({}, styles.factsMatter, this.props.story.template === FACTS_MATTER_TEMPLATE)) },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: html } }),
        keepReadingHTML && React.createElement("div", {
          dangerouslySetInnerHTML: { __html: keepReadingHTML },
          onClick: this.onKeepReadingClick,
          ref: function ref(node) {
            _this3.keepReadingButton = node;
          },
          className: classNames("qa-keep-reading", (_classNames2 = {}, _defineProperty(_classNames2, keepReadingStyles.keepReadingOpen, this.state.isOpen), _defineProperty(_classNames2, keepReadingStyles.keepReadingFixed, this.state.isFixed), _classNames2))
        }),
        hiddenHTML && React.createElement("div", {
          id: "hidden-" + this.props.story.id,
          style: { display: this.state.isOpen ? "block" : "none", paddingBottom: "65px" },
          "aria-hidden": !this.state.isOpen,
          "aria-expanded": this.state.isOpen,
          dangerouslySetInnerHTML: { __html: hiddenHTML } })
      );
    }
  }]);

  return StoryBody;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    stream: selectn("navigation.data.section.slug", state)
  };
};

StoryBody.propTypes = {
  story: PropTypes.object.isRequired,
  storyType: PropTypes.oneOf(["newsletter"]),
  permalinkId: PropTypes.string
};

export default connect(mapStateToProps, { loadStory: loadStory })(StoryBody);


// WEBPACK FOOTER //
// ./src/components/Library/StoryBody/StoryBody.js